import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { useNavigate } from 'react-router-dom';
import ScrollToTop from './ScrollToTop';
import Header from './Header';
import Footer from './Footer';
import { Button } from './ui/button';
import { ArrowLeft } from 'lucide-react';

const TermsConditions = () => {
  const { t } = useLanguage();
  const navigate = useNavigate();

  return (
    <>
      <Header />
      <div className="min-h-screen bg-gradient-to-br from-purple-50 via-pink-50 to-white">
        <ScrollToTop />
        
        {/* Header */}
        <div className="bg-gradient-to-r from-purple-600 via-violet-500 to-fuchsia-500 text-white py-16">
          <div className="container mx-auto px-4">
            <Button 
              onClick={() => navigate('/')} 
              variant="ghost" 
              className="text-white hover:bg-white/20 mb-4"
            >
              <ArrowLeft className="w-4 h-4 mr-2" />
              {t('nav.home')}
            </Button>
            <h1 className="text-4xl md:text-5xl font-bold text-center">{t('legal.terms.title')}</h1>
            <p className="text-center mt-4 text-purple-100">{t('legal.lastUpdated')}: {t('legal.updateDate')}</p>
          </div>
        </div>

      {/* Content */}
      <div className="container mx-auto px-4 py-12 max-w-4xl">
        <div className="bg-white rounded-2xl shadow-xl p-8 md:p-12">
          <div className="prose prose-purple max-w-none">
            
            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">{t('legal.terms.section1.title')}</h2>
              <p className="text-gray-700 leading-relaxed">{t('legal.terms.section1.content')}</p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">{t('legal.terms.section2.title')}</h2>
              <p className="text-gray-700 leading-relaxed mb-4">{t('legal.terms.section2.content')}</p>
              <ul className="list-disc pl-6 text-gray-700 space-y-2">
                <li>{t('legal.terms.section2.item1')}</li>
                <li>{t('legal.terms.section2.item2')}</li>
                <li>{t('legal.terms.section2.item3')}</li>
                <li>{t('legal.terms.section2.item4')}</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">{t('legal.terms.section3.title')}</h2>
              <p className="text-gray-700 leading-relaxed">{t('legal.terms.section3.content')}</p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">{t('legal.terms.section4.title')}</h2>
              <p className="text-gray-700 leading-relaxed">{t('legal.terms.section4.content')}</p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">{t('legal.terms.section5.title')}</h2>
              <p className="text-gray-700 leading-relaxed">{t('legal.terms.section5.content')}</p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">{t('legal.terms.section6.title')}</h2>
              <p className="text-gray-700 leading-relaxed">{t('legal.terms.section6.content')}</p>
            </section>

            <div className="mt-12 p-6 bg-purple-50 rounded-xl border-l-4 border-purple-600">
              <p className="text-gray-700">
                <strong>{t('legal.contact.title')}:</strong><br/>
                Email: <a href="mailto:contact@trakz-studio.com" className="text-purple-600 hover:underline">contact@trakz-studio.com</a>
              </p>
            </div>

          </div>
        </div>
      </div>
    </div>
    <Footer />
  </>
  );
};

export default TermsConditions;
